import ApiService from "../../services/ApiService";

const PromotionEmailService = {
    list: async () => {
        const result = await ApiService.getData("/v1/promotion-email/list");
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to list promotion emails";
        }
        return Array.isArray(result?.content) ? result.content : [];
    },

    getByCode: async (code) => {
        const result = await ApiService.getData("/v1/promotion-email", { code });
        if (result && result.code === "NO_DATA") {
            return null;
        }
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to load promotion email";
        }
        return result;
    },

    recipientCandidates: async (app) => {
        const result = await ApiService.getData("/v1/promotion-email/recipient-candidates", { app });
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to load recipient candidates";
        }
        return result;
    },

    send: async (body) => {
        const result = await ApiService.postData("/v1/promotion-email/send", body);
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to send promotion email";
        }
        return result;
    },

    save: async (body) => {
        const result = await ApiService.postData("/v1/promotion-email", body);
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to save promotion email";
        }
        return result;
    },

    remove: async (code) => {
        const result = await ApiService.deleteData(`/v1/promotion-email?code=${encodeURIComponent(code)}`);
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to delete promotion email";
        }
        return result;
    },
};

export default PromotionEmailService;
